var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomerService01SolidStandard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.91826 9.55404C4.53058 9.07788 5.33022 9.04746 5.96627 9.36548L6.89443 9.82956C7.572 10.1683 8 10.8609 8 11.6184V16.3823C8 17.1399 7.572 17.8324 6.89443 18.1712L5.96627 18.6353C5.33022 18.9533 4.53058 18.9229 3.91826 18.4467C3.46838 18.0969 2.77042 17.5054 2.17589 16.7789C1.60362 16.0797 1 15.1026 1 14.0004C1 12.8982 1.60362 11.9211 2.17589 11.2218C2.77042 10.4954 3.46838 9.90388 3.91826 9.55404Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3C8.13401 3 5 6.13401 5 10V10.5C5 11.0523 4.55228 11.5 4 11.5C3.44772 11.5 3 11.0523 3 10.5V10C3 5.02944 7.02944 1 12 1C16.9706 1 21 5.02944 21 10V10.5C21 11.0523 20.5523 11.5 20 11.5C19.4477 11.5 19 11.0523 19 10.5V10C19 6.13401 15.866 3 12 3Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 16.5C20.5523 16.5 21 16.9477 21 17.5V18C21 20.7614 18.7614 23 16 23H12C11.4477 23 11 22.5523 11 22C11 21.4477 11.4477 21 12 21H16C17.6569 21 19 19.6569 19 18V17.5C19 16.9477 19.4477 16.5 20 16.5Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0337 9.36548C18.6698 9.04746 19.4694 9.07788 20.0817 9.55404C20.5316 9.90388 21.2296 10.4954 21.8241 11.2218C22.3964 11.9211 23 12.8982 23 14.0004C23 15.1026 22.3964 16.0797 21.8241 16.7789C21.2296 17.5054 20.5316 18.0969 20.0817 18.4467C19.4694 18.9229 18.6698 18.9533 18.0337 18.6353L17.1056 18.1712C16.428 17.8324 16 17.1399 16 16.3823V11.6184C16 10.8609 16.428 10.1683 17.1056 9.82956L18.0337 9.36548Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerService01SolidStandard);
export default __webpack_public_path__ + "static/media/customer-service-01-solid-standard.2e049af7cf268057ffe509ab52e7520d.svg";
export { ForwardRef as ReactComponent };